// extracted by mini-css-extract-plugin
export var clickThrough = "_yl-2";
export var fallback = "_yl-5";
export var frame = "_yl-3";
export var frameCell = "_yl-1";
export var overlay = "_yl-4";
export var wrapper = "_yl-0";